import React from 'react';
import { Database } from 'lucide-react';
import { BookingSettingsResponseDto } from '../../types/booking';
import Spinner from '../Spinner';

interface Props {
  settings?: BookingSettingsResponseDto | null;
  loading?: boolean;
}

// The backend only exposes CRM sync as an enabled flag on BookingSettings
// (no dedicated status/provider/last-sync endpoint), so this reflects enabled/disabled state only.
export default function CrmSyncStatus({ settings, loading }: Props) {
  if (loading) {
    return (
      <div className="flex items-center gap-3 p-6">
        <Spinner size="h-6 w-6" />
        <span className="text-sm text-strivre-mutedtext">Loading CRM sync status...</span>
      </div>
    );
  }

  if (!settings || !settings.crmSyncEnabled) {
    return (
      <div className="p-6 text-center text-sm text-strivre-mutedtext">
        No CRM configured.
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <div className="p-2 rounded-lg bg-strivre-lightnavy text-strivre-navy">
        <Database size={18} />
      </div>
      <div>
        <p className="text-sm font-semibold text-strivre-navy">CRM Sync Enabled</p>
        <p className="text-xs text-strivre-mutedtext">Contacts and appointments will sync automatically.</p>
      </div>
    </div>
  );
}

